import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SeparatorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center"
    },
    defaultLength: {
        alignSelf: "stretch"
    },
    title: {
        flexShrink: 1
    },
    indicator: {
        flex: 1
    }
});

export const useStyles = ({
    customColor,
    orientation,
    borders,
    colors,
    length,
    spaces,
    color
}: SeparatorDynamicStyleType) => {
    const styles = {
        indicator: {
            backgroundColor: customColor ? colors.project[customColor as keyof NCoreUIKit.ProjectColorPalette] ?? customColor : colors.content.border[color]
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(orientation === "horizontal") {
        styles.container.flexDirection = "row";

        styles.indicator.height = borders.separator;
    } else {
        styles.container.flexDirection = "column";

        styles.indicator.width = borders.separator;
    }

    if(length === undefined) {
        Object.assign(styles.container, stylesheet.defaultLength);
    } else if(orientation === "horizontal") {
        styles.container.width = length;
    } else {
        styles.container.height = length;
    }

    return styles;
};
export default stylesheet;
